import { FC } from "react";
import classNames from "classnames";
import { RowSeat, SeatType } from "src/Modules/Flights/constants/JourneyDetails";
import { useSSRContext } from "../../../../context/SSRContext";
import { track } from "@amplitude/analytics-browser";
import { SEAT_VISUAL_CONFIG, getSeatVisualState } from "./seatVisualState";

const EXIT_ROW_TYPES = ["WindowExitRow", "AisleExitRow", "MiddleExitRow", "WindowWingExitRow"];

const Seat: FC<{
  seatData: SeatType;
  onClick: any;
  reservedSeats: Set<string>;
}> = ({
  seatData,
  onClick,
  reservedSeats,
}) => {
  const isAvailable = seatData?.availabilityType === "Open";
  const isSelected = reservedSeats.has(seatData.code);
  const isExitRow = EXIT_ROW_TYPES.includes(seatData.seatSubType);
  const visual = SEAT_VISUAL_CONFIG[getSeatVisualState(isAvailable, isSelected, isExitRow)];
  const { getSSRItem } = useSSRContext();
  const handleClick = () => {
    const seatSelected = Object.keys(getSSRItem("seats"))?.[0];
    if (seatSelected === seatData.code) {
      track("Seat Unselected",{
        ...seatData
      })
      return onClick({});
    }
    if (isSelected) {
      return;
    }
    track("Seat Selected",{
      ...seatData
    })
    onClick({ [seatData.code]: seatData });

  };

  return (
        <button
          className={classNames(
            "relative! m-0! p-0! flex! h-full! w-full! flex-1! cursor-pointer! select-none! items-center! justify-center!",
            "aspect-square! bg-transparent! border-none! shadow-none! transition-colors! rounded-sm!",
          )}
          disabled={!isAvailable}
          onClick={handleClick}
        >
          {visual.transform(seatData)}
        </button>
      
  );
};

const Gap: FC<{ colStart: number; rowNo?: string }> = ({ colStart, rowNo }) => {
  return (
    <div
      style={{
        gridRowStart: 1,
        gridColumn: `${colStart} / span 1`,
      }}
      className="text-font-minimal font-poppins flex items-center justify-center text-xs"
    >
      {rowNo}
    </div>
  );
};

const RowItem: FC<{
  col: [number, string];
  row: RowSeat;
  onClick: any;
  reservedSeats: Set<string>;
}> = ({
  col,
  row,
  onClick,
  reservedSeats,
}) => {
  const isGap = col[1] === "GAP";
  const seatData = row.seats.find((element) => element.seatNo === col[1]);
  if (isGap) return <Gap colStart={col[0]} rowNo={row.seats?.[0]?.rowNo} />;
  if (seatData) return <Seat seatData={seatData} onClick={onClick} reservedSeats={reservedSeats} />;

  return null;
};

export default RowItem;
